import { ComponentStylesWithFns, StyleStates } from '../../../theme/styles.helpers';
import { Orders } from '@hellohair/types';

interface RequestModalActionsStylesProps extends StyleStates {
  confirmAction: 'accept' | 'deny' | null;
  orderState: Orders.OrderRequestState | undefined;
}

export const RequestModalActionsStyles: ComponentStylesWithFns<RequestModalActionsStylesProps> = {
  card: {
    backgroundColor: 'white',
    border: '1px solid #dce4ee',
    borderRadius: '12px',
    padding: '16px',
    flexShrink: 0,
  },
  cardLabel: {
    fontSize: '10px',
    fontWeight: 700,
    color: '#a0aab9',
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    marginBottom: '10px',
    '& span': {
      fontWeight: 300,
      textTransform: 'none',
      letterSpacing: 'normal',
    },
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#ebf2f6',
      borderRadius: '8px',
      fontSize: '14px',
      '& fieldset': { borderColor: '#dce4ee' },
      '&:hover fieldset': { borderColor: '#c5d0df' },
      '&.Mui-focused fieldset': { borderColor: '#4881d7' },
    },
    mb: 1.5,
  },
  buttonRow: {
    display: 'flex',
    gap: '12px',
    marginTop: '10px',
  },
  denyButton: {
    flex: 1,
    height: '46px',
    lineHeight: '46px',
    borderRadius: '40px',
    borderColor: '#fca5a5',
    color: '#ec3939',
    fontSize: '14px',
    fontWeight: 600,
    '&:hover': { backgroundColor: '#fff5f5', borderColor: '#fca5a5' },
  },
  acceptButton: {
    flex: 2,
    height: '46px',
    lineHeight: '46px',
    borderRadius: '40px',
    backgroundColor: '#4881d7',
    fontSize: '14px',
    fontWeight: 600,
    '&:hover': { backgroundColor: '#3a6bc0' },
  },
  cancelButton: {
    flex: 1,
    height: '46px',
    lineHeight: '46px',
    borderRadius: '40px',
    fontSize: '14px',
  },
  confirmButton: ({ confirmAction }) => [
    {
      flex: 1,
      height: '46px',
      lineHeight: '46px',
      borderRadius: '40px',
      fontSize: '14px',
    },
    confirmAction === 'accept' && {
      backgroundColor: '#4881d7',
      '&:hover': { backgroundColor: '#3a6bc0' },
    },
    confirmAction === 'deny' && {
      backgroundColor: '#ec3939',
      '&:hover': { backgroundColor: '#c82020' },
    },
  ],
  confirmText: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#111',
    mb: 1.5,
    textAlign: 'center',
  },
  statusText: ({ orderState }) => [
    {
      fontSize: '14px',
      fontWeight: 600,
      textAlign: 'center',
      mt: 1,
    },
    orderState === Orders.OrderRequestState.ALLOWED && { color: '#15803d' },
    orderState !== Orders.OrderRequestState.ALLOWED && { color: '#ec3939' },
  ],
};
